import React from 'react';
import { Divider } from 'antd';
import { RomoocFeeMain } from './romooc-fee-main';

const RomoocFee = ({
  dataFeeRomooc,
  setDataFeeRomooc,
  locationSelected,
  locationPackingList,
  reloadAfterUpdate,
  // contractStatus,
  isNew,
  valueDetail = null,
}) => {
  return (
    <>
      <Divider>Phí neo Romooc</Divider>
      <RomoocFeeMain
        dataFeeRomooc={dataFeeRomooc}
        setDataFeeRomooc={setDataFeeRomooc}
        locationSelected={locationSelected}
        locationPackingList={locationPackingList}
        reloadAfterUpdate={reloadAfterUpdate}
        // contractStatus={contractStatus}
        isNew={isNew}
        valueDetail={valueDetail}
      />
    </>
  );
};

export { RomoocFee };
